export const keys = {
  ENTER: { keyName: 'Enter', keyCode: '13' },
  SPACE: { keyName: ' ', keyCode: '32' },
  ESCAPE: { keyName: 'Escape', keyCode: '27' },
  ARROW_UP: { keyName: 'ArrowUp', keyCode: '38' },
  ARROW_DOWN: { keyName: 'ArrowDown', keyCode: '40' },
  HOME: { keyName: 'Home', keyCode: '36' },
  END: { keyName: 'End', keyCode: '35' },
  PAGEUP: { keyName: 'PageUp', keyCode: '33' },
  PAGEDOWN: { keyName: 'PageDown', keyCode: '34' },
  ALPHANUMERIC: { keyName: /^[a-z0-9]$/, keyCode: /^4[8-9]|5[0-7]|6[5-9]|[7-8][0-9]|90$/ },
};

export const focusOnPreviousOption = (elements: Array<HTMLElement>) => {
  if (!document.activeElement) return;
  const position = elements.indexOf(document.activeElement as HTMLElement);
  const previousOption = elements[position - 1];
  if (previousOption) {
    return previousOption.focus();
  }
  elements[elements.length - 1].focus();
};

export const focusOnNextOption = (elements: Array<HTMLElement>) => {
  const position = elements.indexOf(document.activeElement as HTMLElement);
  const nextOption = elements[position + 1];
  if (nextOption) {
    return nextOption.focus();
  }
  elements[0].focus();
};
